// extracted by mini-css-extract-plugin
export default {"cards":"ResourcesSection-module__cards__BY5IzbI"};